import { render } from "./HowBuyPump.vue?vue&type=template&id=0b581b80&scoped=true"
import script from "./HowBuyPump.vue?vue&type=script&lang=js"
export * from "./HowBuyPump.vue?vue&type=script&lang=js"

import "./HowBuyPump.vue?vue&type=style&index=0&id=0b581b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b581b80"]])

export default __exports__